import React, { useState, useEffect } from "react";
import Preloader from "../src/components/Pre";
import TopNav from "./components/TopNav";
import IconRail from "./components/IconRail";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Projects from "./components/Projects/Projects";
import Footer from "./components/Footer";
import Resume from "./components/Resume/ResumeNew";
import AdminConsole from "./components/Admin/AdminConsole";
import VisitorConsole from "./components/Admin/VisitorConsole";
import StyleGuide from "./components/StyleGuide/StyleGuide";
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import "./style.css";
import "./tokens.css";
import "./ui/tokens.css";
import "./glass.css";
import "./grid.css";
import "./type.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <IconRail />
        <TopNav />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/project" element={<Projects />} />
          <Route path="/about" element={<About />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/admin" element={<AdminConsole />} />
          <Route path="/admin/visitors" element={<VisitorConsole />} />
          <Route path="/style-guide" element={<StyleGuide />} />
          {/* <Route path="*" element={<Navigate to="/"/>} /> */}
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
